import { useQuery } from '@tanstack/react-query';
import { GET_CART } from '@/constants/API';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { Cart, RemovedCartItems } from '@/types/cart';
import storage from '@/utils/storage';

export type CartDetails = {
  cart_data: Cart;
  removed_cart_items: RemovedCartItems | null;
};

export type GetCart = {
  home_screen: boolean;
  isEnable?: boolean;
};

export const getCartDetails = async (payload: GetCart) => {
  const currentLocation = storage.getItem('currentLocation');
  const cartRef = storage.getItem('cartRef') ?? null;
  const webAccessToken = storage.getItem('webAccessToken');
  const config = storage.getItem('config');
  const firsTimeLoggedIn = sessionStorage.getItem('FIRST_TIME_LOGGED_IN');

  let obj = {};

  if (config?.auth_skip && Boolean(!firsTimeLoggedIn) && webAccessToken) {
    obj = {
      ...payload,
      location_id: currentLocation.id,
      home_screen: payload.home_screen ?? false,
      cart_ref: cartRef,
    };
  } else {
    obj = {
      ...payload,
      location_id: currentLocation.id,
      home_screen: payload.home_screen ?? false,
    };
  }
  try {
    const data = await axios.post<CartDetails>(GET_CART, obj);
    if (data && webAccessToken) {
      sessionStorage.setItem('FIRST_TIME_LOGGED_IN', '1');
    }
    if (data?.cart_data?.cart_ref) {
      storage.setItem('cartRef', data?.cart_data?.cart_ref);
    }
    if (!data?.cart_data?.cart_ref) {
      storage.removeItem('cartRef');
    }
    if (Object.keys(data?.cart_data?.cart_items).length === 0 || data?.cart_data === null) {
      storage.removeItem('cartRef');
    }
    return data;
  } catch (error) {
    return null;
  }
};

type CartDetailsQueryFnType = typeof getCartDetails;

export const useCartDetails = (payload: GetCart) =>
  useQuery<ExtractFnReturnType<CartDetailsQueryFnType>>({
    queryKey: ['cartDetails'],
    queryFn: async () => await getCartDetails(payload),
    staleTime: 0,
    enabled: payload.isEnable ?? true,
  });
